import { Company } from "../models/Company";
import { Po } from "../models/Po";
import { VendorBlockingData } from "../models/VendorBlocking/VendorBlockingData";
import { VendorBlockMeta } from "../models/VendorBlocking/VendorBlockMeta";
import { AxiosConfig } from "./AxiosConfig";
import qs from "qs";
import { VendorBlockinViewData } from "../models/VendorBlocking/VendorBlockinViewData";

const getBlockingMetaData = async (
    successCallback: (vendorBlockMetaData: VendorBlockMeta) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get("/VendorBlock/GetVendorBlockMasterData");
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

  const getExistingVendorBlock = async (
    vendorNo:string,
    coCode:string,
    poCode:string,
    successCallback: (existingVendorBlock: VendorBlockingData) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get('/VendorBlock/GetExistingVendorBlock?vendorNo=' + vendorNo + '&coCode=' + coCode + '&poCode=' + poCode );
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

  const checkExistingVendorBlock = async (
    vendorNo:string,
    coCode:string,
    successCallback: (requestNo: string) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get('/VendorBlock/CheckVendorBlockExists?vendorNo=' + vendorNo + '&coCode=' + coCode  );
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

export const checkForVendorUnBlock = async (
  vendorNo: string,
  coCode: string
): Promise<string> => {
  try {
    const resp = await AxiosConfig.get<string>(
      `/VendorBlock/CheckForVendorUnBlock`,
      {
        params: { vendorNo, coCode },
      }
    );

    return resp.data; // ✅ string from API
  } catch (err) {
    console.error(err);
    throw err; // ✅ let caller handle error
  }
};

const submitVendorBlockRequest = async (
  vendorBlockSubmitData: VendorBlockingData,
    successCallback: (vendorBlockData: any) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.post("/VendorBlock/BlockVendor", vendorBlockSubmitData);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

  const getCompany = async (
    successCallback: (companyData: Array<Company>) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get("/VendorBlock/BlockVendor");
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };
  
  const getPO = async (
    companyCode: string,
    successCallback: (poData: Array<Po>) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get("/VendorBlock/BlockVendor", {
        params: { companyCode: companyCode },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: "repeat" });
        },
      });
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

  const getSavedBlockingData = async (
    requestId: number,
    successCallback: (bockData: VendorBlockinViewData) => void,
    errorCallback: (error: Error) => void
  ) => {
    try {
      const resp = await AxiosConfig.get("/VendorBlock/GetVendorBlockDetails?requestId=" + requestId);
      successCallback(resp.data);
    } catch (err: any) {
      // Handle Error Here
      console.error(err);
      errorCallback(err);
    }
  };

export const VendorBlockingService = {
    getBlockingMetaData,
    submitVendorBlockRequest,
    getCompany,
    getPO,
    getSavedBlockingData,
    getExistingVendorBlock: getExistingVendorBlock,
    checkExistingVendorBlock: checkExistingVendorBlock,
    CheckForVendorUnBlock:checkForVendorUnBlock
  };


